var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.key)?_c('span',{key:_vm.key},[(_vm._to_add)?_c('span',{on:{"click":function($event){return _vm.add()}}},[_c('button-vue',{attrs:{"type":"clip_in","title":"Dodaj do notatnika"}})],1):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }